var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 4.22876 0 2.34315 1.17157 1.17157C2.34315 0 4.22876 0 8 0H12C15.7712 0 17.6569 0 18.8284 1.17157C20 2.34315 20 4.22876 20 8V12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20H8C4.22876 20 2.34315 20 1.17157 18.8284C0 17.6569 0 15.7712 0 12V8ZM5.73867 14.4465C6.96118 13.5085 8.45906 13 10 13C11.5409 13 13.0388 13.5085 14.2613 14.4465C15.4838 15.3846 16.3627 16.6998 16.7615 18.1883C16.9044 18.7217 16.5878 19.2701 16.0544 19.413C15.5209 19.556 14.9726 19.2394 14.8296 18.7059C14.5448 17.6427 13.917 16.7033 13.0438 16.0332C12.1706 15.3632 11.1007 15 10 15C8.89933 15 7.82942 15.3632 6.95619 16.0332C6.08297 16.7033 5.45525 17.6427 5.17037 18.7059C5.02743 19.2394 4.47909 19.556 3.94563 19.413C3.41216 19.2701 3.09558 18.7217 3.23852 18.1883C3.63734 16.6998 4.51616 15.3846 5.73867 14.4465ZM8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7ZM10 3C7.79086 3 6 4.79086 6 7C6 9.20914 7.79086 11 10 11C12.2091 11 14 9.20914 14 7C14 4.79086 12.2091 3 10 3Z",
    fill: "#5F6C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.348a847a85bf23608cbe6cb117058927.svg";
export { ForwardRef as ReactComponent };